import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceWithConfigParserPipe } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/pipe/product/price-with-config-parser.pipe';

@NgModule({
  declarations: [PriceWithConfigParserPipe],
  exports: [PriceWithConfigParserPipe],
  imports: [CommonModule],
})
export class ProductPriceParserModule {}
